<template>
   <!-- 热点图轮播 start-->
   <div class="hotspotImgs hotspotSwiper">
          <!-- Swiper pic start -->
          <div class="swiper-container swiper-containerPic">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper-slide-img" v-for="(items,index) in swiperImagesData[swiperImagesData.nowHotspot]" :key="index">
                    <img :src="items" >
                </div> 
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="slideNext"></div>
            <div class="swiper-button-prev" @click="slidePrev"></div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination" ></div>
          </div>
          <!-- Swiper pic end-->
          <div class="closeBtns" @click="closeSwiper">
              <svg t="1586328754163" class="icon closeBtnBj" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9943" width="200" height="200"><path d="M71.675 962l-9.675-900 890.325 900z" p-id="9944" fill="#d81e06"></path></svg>
              <svg t="1586328854214" class="icon closeBtn" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10841" width="200" height="200"><path d="M153.998 113.778l756.224 756.224-40.22 40.22-756.224-756.224z" fill="#e6e6e6" p-id="10842"></path><path d="M870.002 113.778l40.22 40.22-756.224 756.224-40.22-40.22z" fill="#e6e6e6" p-id="10843"></path></svg>
          </div>
   </div>
   <!-- 热点图轮播 end-->
</template>

<style type="text/css">
    .hotspotSwiper{ width: 100%!important; height: 100vh!important; background-color: rgba(0,0,0,0.8)!important; top:0px!important; left: 0px!important; z-index: 99999!important;     display: flex!important;
    position: fixed!important;justify-content: center!important;align-items: center!important;  }
     .swiper-slide-img {
      text-align: center!important;
      background: transparent!important;border-radius: 0rem!important;
      display: -webkit-box!important;
      display: -ms-flexbox!important;
      display: -webkit-flex!important;
      display: flex!important;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center!important;
      align-items: center!important;
      color: #333!important;
      width: 100%!important;
      height: 100vh!important;
    }
    .swiper-containerPic{ height: 100vh!important; }
    .swiper-slide-img img{ max-width: 10rem!important; height: auto!important }
   .swiper-pagination-bullet{    background: #fff!important;}
   svg.closeBtnBj{ top:-0.1rem; right: -0.1rem;  width: 1.5rem; height: 1.5rem;    transform: rotate(180deg);    -webkit-transform: rotate(180deg);}
   svg.closeBtn{ top:0.12rem; right: 0.12rem; width: 0.5rem;  height: 0.5rem;}
   .closeBtns svg.icon{ position: absolute; }
   .closeBtns{ z-index: 99999 }

   @media screen and (max-width: 450px) {
     .swiper-slide-img img{ max-width: 100%!important; height: auto }
     .swiper-button-next, .swiper-button-prev{ zoom:0.6; }
  } 
</style>
<script type="text/javascript">
	export default{
		name:'swiperImgs',
		props:['swiperImagesData'],
		data(){
			return {
				swiperPic:''
			}
		},
		mounted (){
                //初始化热点轮播图
                this.initPicSwiper();
                /*console.log(this.swiperImagesData);*/
		},
		methods:{
             initPicSwiper(){
                    let that=this;
                    var swiperPic = new Swiper('.swiper-containerPic', {
        　　　　　　  direction:"horizontal",
        　　　　 　　 loop:false,
        　　　　　　  pagination:".swiper-pagination",
                      autoplayDisableOnInteraction: false,
                      onTransitionEnd: function (swiper) {
                            //console.info("页面跳转到第:", swiper.activeIndex, " 页");
                            that.siteSwiperImgIndex(swiper.activeIndex);
                      }
                    });
                    this.swiperPic=swiperPic;
              },
              slideNext(){
                console.log(this.swiperPic.activeIndex)
                this.swiperPic.slideNext();
              },
              slidePrev(){
                this.swiperPic.slidePrev();
              },
              siteSwiperImgIndex(index){
                this.$emit('siteEventSwiperImgIndex',index);
              },
              closeSwiper(){
                this.$emit('closeEventer');
              },
              callMethod(index){
                this.swiperPic.slideTo(index);
              }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/swiperImgs.vue